// oxlint-disable-next-line no-restricted-imports
import { Dialog, type DialogProps } from "@mui/material";
import { mergeSlotProps } from "@mui/material/utils";
import React, { type ReactElement, useId } from "react";

import {
  AppDialogCloseButton,
  type DialogCloseReason,
} from "./AppDialogCloseButton.tsx";
import { AppDialogTitleIdProvider } from "./appDialogTitleId.context.tsx";

export type AppDialogProps = Omit<DialogProps, "onClose" | "maxWidth"> & {
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  onClose?: (event: any, reason: DialogCloseReason) => void;
  hideXClose?: boolean;
  maxWidth?: string | number;
};

/** Reserves the title id that `AppDialogHeader` claims, unless the caller names the dialog from another element. */
export function AppDialog({
  children,
  onClose,
  hideXClose = false,
  slotProps,
  maxWidth = "600px",
  ...rest
}: AppDialogProps): ReactElement {
  const titleId = useId();

  return (
    <Dialog
      fullWidth
      aria-labelledby={titleId}
      {...rest}
      onClose={onClose}
      slotProps={{
        ...slotProps,
        paper: mergeSlotProps(slotProps?.paper, {
          sx: rest.fullScreen ? undefined : { maxWidth },
          onClick: (event: React.MouseEvent) => event.stopPropagation(),
        }),
      }}
    >
      <AppDialogTitleIdProvider
        titleId={rest["aria-labelledby"] === undefined ? titleId : undefined}
      >
        {onClose && !hideXClose && <AppDialogCloseButton onClose={onClose} />}
        {children}
      </AppDialogTitleIdProvider>
    </Dialog>
  );
}
